import React, { useEffect } from 'react';
import ds from '@/styles/ds/ds.module.scss';

import ClaimButton from '../ClaimButton/ClaimButton';
import Loader_Button_Primary from '../ClaimButton/Loader_Button_Primary/Loader_Button_Primary';

import useForfeitReward from '../../hooks/useForfeitReward/useForfeitReward';
import { useModalStoreActions, useNotificationsStoreActions } from '@/store';
import Notification_Toast_Primary from '@/components/Notifications/Notification_Toast_Primary/Notification_Toast_Primary';

interface ForfeitModalProps {
	bonusId: string;
}

const ForfeitModal = ({ bonusId }: ForfeitModalProps) => {
	const { addNotification } = useNotificationsStoreActions();
	const { setModalStatus } = useModalStoreActions();
	const { data, error, loading, forfeitReward } = useForfeitReward();

	const handleCloseClick = async (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		e.preventDefault();
		e.stopPropagation();
		setModalStatus(null);
	};

	const handleForfeit = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		await forfeitReward(bonusId);
	};

	return (
		<div
			className="p-5 md:p-10 h-min my-auto max-w-[390px] flex flex-col gap-6 popup"
			style={{
				borderRadius: '8px',
				background: '#282C32',
				boxShadow: '0px 5px 30px 0px rgba(0, 0, 0, 0.60)',
			}}
		>
			<div className="flex flex-col gap-3 text-center ">
				<p className=" text-[18px] font-bold">
					Are you sure you would like to forfeit your active bonus?
				</p>
				<p className=" text-sm px-2 text-pretty">
					By forfeiting your active bonus, you will LOSE your active bonus, and
					all associated winnings tied to your bonus. This action CANNOT be
					undone once taken.
				</p>
			</div>
			<div className="flex flex-col gap-4 ">
				<button
					aria-label="Forfeit Bonus"
					className={`${ds.primary} ${ds.purpleWhite}   flex h-10 items-center  `}
					onClick={(e) => handleForfeit(e)}
				>
					{loading ? <Loader_Button_Primary /> : 'Yes, forfeit my active bonus'}
				</button>
				<button
					aria-label="Close"
					className={` h-10 !rounded-[5px] !bg-[#2C343D] font-bold motion-safe:hover:!text-dove-white text-dove-white `}
					onClick={(e) => handleCloseClick(e)}
				>
					Close
				</button>

				{error ? (
					<p className="text-[#FB401C] text-xs text-center px-3">
						An error occurred while trying to forfeit your bonus. Please try
						again.
					</p>
				) : null}
			</div>
		</div>
	);
};

export default ForfeitModal;
